import { render, staticRenderFns } from "./Chapters.vue?vue&type=template&id=3af7554a"
import script from "./Chapters.vue?vue&type=script&lang=js"
export * from "./Chapters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports